import React from 'react';

import Arrow from './Arrow.jsx';
import { Block } from './Block.jsx';
import { default as Image } from './Image.jsx';
import Name from './Name.jsx';
import Utilities from './Utilities.jsx';

function SlideshowDot(props) {
    let imageUrl;
    if (props.image) {
        imageUrl = Image.url(props.image, undefined, props.width || 320, undefined, undefined, props.backgroundColor);
    } else if (props.imageUrl) {
        imageUrl = props.imageUrl;
    }
    let className = 'owl-dot';
    if (props.className) {
        className += ` ${props.className}`;
    }
    return <div className={className} style={{ backgroundImage: `url('${imageUrl}')` }}></div>;
}

function withSlideshowConfiguration(WrappedComponent, defaults) {
    return function (props) {
        const [dotsId, setDotsId] = React.useState(`slider--dots-${props.sliderId}`);
        const [navId, setNavId] = React.useState(`slider--nav-${props.sliderId}`);
        React.useEffect(() => {
            setDotsId(`slider--dots-${props.sliderId}`)
            setNavId(`slider--nav-${props.sliderId}`)
        }, [props.sliderId])
        React.useEffect(() => props.onRegisterConfigHandler(config => {
            if (props.dotsEnabled) {
                config.dotsContainer = `#${dotsId}`;
            }
            if (props.navEnabled) {
                config.navContainer = `#${navId}`
            }
        }), []);

        const getMobileStyle = () => {
            let style = '';
            if (props.blockConfig.slideshow) {
                if (props.blockConfig.slideshow.minHeightMobile && props.blockConfig.slideshow.minHeightMobile.value && props.blockConfig.slideshow.minHeightMobile.value.length > 0) {
                    style += `min-height:${props.blockConfig.slideshow.minHeightMobile.value}${props.blockConfig.slideshow.minHeightMobile.unit}!important;`;
                }
                if (props.blockConfig.slideshow.maxHeightMobile && props.blockConfig.slideshow.maxHeightMobile.value && props.blockConfig.slideshow.maxHeightMobile.value.length > 0) {
                    style += `max-height:${props.blockConfig.slideshow.maxHeightMobile.value}${props.blockConfig.slideshow.maxHeightMobile.unit}!important;`;
                }
            }
            return style;
        }
        React.useEffect(() => {
            if (!props.sliderId || props.builder) {
                return;
            }
            const style = getMobileStyle();
            if (style) {
                Utilities.addMobileStyle(`cont-${props.sliderId}`, style)
            }
        }, [props.sliderId])
        const [mobileStyle, setMobileStyle] = React.useState(undefined);
        if (props.builder && props.blockConfig.slideshow) {
            React.useEffect(() => {
                if (!props.initializing) {
                    props.onReinit()
                }
            }, [props.blockConfig.slideshow.columns]);

            if (!props.blockConfig.slideshow.navOffset) {
                props.blockConfig.slideshow.navOffset = { 'unit': '%' };
            }
            if (!props.blockConfig.slideshow.columnSpacing) {
                props.blockConfig.slideshow.columnSpacing = { 'unit': 'px', 'value': '40' };
            }
            if (!props.blockConfig.slideshow.marginLeft) {
                props.blockConfig.slideshow.marginLeft = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.marginRight) {
                props.blockConfig.slideshow.marginRight = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.maxWidth) {
                props.blockConfig.slideshow.maxWidth = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.paddingLeft) {
                props.blockConfig.slideshow.paddingLeft = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.paddingRight) {
                props.blockConfig.slideshow.paddingRight = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.maxHeightMobile) {
                props.blockConfig.slideshow.maxHeightMobile = { 'unit': 'px' };
            }
            if (!props.blockConfig.slideshow.minHeightMobile) {
                props.blockConfig.slideshow.minHeightMobile = { 'unit': 'px' };
            }
            React.useEffect(() => {
                if (!props.initializing) {
                    props.onReinit(true)
                }
            },
                [
                    props.blockConfig.slideshow.animationDuration,
                    props.blockConfig.slideshow.autoplayTimeout,
                    props.blockConfig.slideshow.columnSpacing.value,
                    props.blockConfig.slideshow.marginLeft.value,
                    props.blockConfig.slideshow.marginRight.value,
                    props.blockConfig.slideshow.maxWidth.value,
                    props.blockConfig.slideshow.paddingLeft.value,
                    props.blockConfig.slideshow.paddingRight.value,
                    props.blockConfig.slideshow.maxHeightMobile.value,
                    props.blockConfig.slideshow.minHeightMobile.value
                ]
            )
            React.useEffect(() => {
                if (!props.sliderId) {
                    return;
                }
                const style = getMobileStyle();
                if (style) {
                    setMobileStyle(Utilities.createMobileStyle(`cont-${props.sliderId}`, style));
                }
            }, [props.sliderId, props.blockConfig.slideshow.maxHeightMobile.value, props.blockConfig.slideshow.minHeightMobile.value]);
        }
        const _defaults = defaults || {};
        let arrowOffset = _defaults.arrowOffset || 0;
        const arrowStyle = { pointerEvents: props.builder ? 'none' : undefined };
        if (_defaults.arrowStyle) {
            Utilities.copyObject(_defaults.arrowStyle, arrowStyle);
        }
        const navStyle = _defaults.navStyle ? { ..._defaults.navStyle } : {};
        const layoutStyles = Block.mapLayoutStyleConfigPropsWithPageKit({}, props, { alignment: 'textAlign', configKey: 'slideshow' }, (propName, propValue, propUnit) => {
            switch (propName) {
                case 'arrowColor':
                    arrowStyle.color = propValue;
                    return true;
                case 'arrowOffset':
                    if (propValue && propValue.length > 0) {
                        arrowOffset = `${propValue}${propUnit}`;
                    }
                    return true;
                case 'arrowSize':
                    if (propValue && propValue.length > 0) {
                        arrowStyle.fontSize = `${propValue}${propUnit}`;
                    }
                    return true;
                case 'cell':
                case 'columns':
                case 'columnSpacing':
                case 'enabled':
                case 'maxHeightMobile':
                case 'minHeightMobile':
                    return true;
                case 'navOffset':
                    if (propValue && propValue.length > 0) {
                        navStyle.top = `${propValue}${propUnit}`;
                    }
                    return true;
            }
        });
        const containerStyle = layoutStyles.containerStyle || {};
        Utilities.copyObject(props.style, containerStyle);

        let arrows;
        if (props.navEnabled) {
            arrows = (
                <div id={navId} className="slider--nav" style={navStyle}>
                    <Arrow direction="prev" offset={arrowOffset} style={arrowStyle} onClick={props.onPrevious} />
                    <Arrow direction="next" offset={arrowOffset} style={arrowStyle} onClick={props.onNext} />
                </div>
            );
        }
        const blockPropsHandler = (d) => {
            if (!d.type) {
                return;
            }
            switch (d.type.value) {
                case Name.Block.Columns:
                    if (!d.config || !d.config.layout || !d.config.layout.minHeight || !d.config.layout.minHeight.value || d.config.layout.minHeight.value.length == 0) {
                        return;
                    }
                    return { style: { height: '100%' } }
            }
        }
        return (
            <>
                {
                    mobileStyle != undefined &&
                    <style dangerouslySetInnerHTML={{ __html: mobileStyle }} />
                }
                <WrappedComponent
                    {...props}
                    arrows={arrows}
                    blockPropsHandler={blockPropsHandler}
                    builderBlockPropsHandler={blockPropsHandler}
                    containerStyle={containerStyle}
                    dotsId={dotsId}
                    id={`cont-${props.sliderId}`}
                    style={layoutStyles.style}>
                    {props.children}
                </WrappedComponent>
            </>
        )
    }
}

const slideshowInstances = {};
function withSlideshowInitialization(WrappedComponent, config, autoinitialize) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            let sliderId;
            if (props.builder) {
                sliderId = this._getSliderId(props);
            }
            const _config = Object.assign({}, config);
            this.state = {
                config: _config,
                page: { index: 0 },
                sliderId
            }

            this._destroySlider = this._destroySlider.bind(this);
            this._getSliderId = this._getSliderId.bind(this);
            this._initialize = this._initialize.bind(this);
            this._initSlider = this._initSlider.bind(this);

            this.handleNext = this.handleNext.bind(this);
            this.handlePrevious = this.handlePrevious.bind(this);
            this.handleRegisterConfigHandler = this.handleRegisterConfigHandler.bind(this);
            this.handleReinit = this.handleReinit.bind(this);
            this.handleTranslated = this.handleTranslated.bind(this);
        }

        componentDidMount() {
            if (!this.props.blockIdentifier || (this.props.builder && autoinitialize == false)) {
                return;
            }
            this._initialize();
        }

        componentDidUpdate(prevProps) {
            if (this.props.blockIdentifier && this.props.blockIdentifier != prevProps.blockIdentifier) {
                this._initialize();
            } else if (this.props.visible && !prevProps.visible && !this.state.initialized) {
                this._initSlider();
            } else if (!this.props.visible && this.props.listData && prevProps.listData && this.props.listData.length != prevProps.listData.length) {
                this.handleReinit();
            }
        }

        componentWillUnmount() {
            slideshowInstances[this.props.blockIdentifier] = undefined;

            this._destroySlider();

            if (this._reinitTimeoutId) {
                clearTimeout(this._reinitTimeoutId);
                this._reinitTimeoutId = undefined;
            }
        }

        _destroySlider() {
            if (this.carousel) {
                $(this.carousel).owlCarousel('destroy')
                this.carousel = undefined;
            }
        }

        _getSliderId(props) {
            return `slider-${props.blockIdentifier}`;
        }

        _initialize() {
            slideshowInstances[this.props.blockIdentifier] = true;

            this.setState({
                initialized: undefined,
                sliderId: this._getSliderId(this.props)
            }, this._initSlider);
        }

        _initSlider() {
            // if (this.props.builder || this.props.visible == false || !slideshowInstances[this.props.blockIdentifier] || this.state.initializing) {
            if (this.props.visible == false || !slideshowInstances[this.props.blockIdentifier] || this.state.initializing) {
                return;
            }
            this.setState({
                initializing: true
            });
            // this._destroySlider();

            setTimeout(() => {
                if (!slideshowInstances[this.props.blockIdentifier]) {
                    return;
                }

                let _config = this.state.config;
                _config.onInitialized = () => {
                    this.setState({
                        currentIndex: undefined,
                        initialized: true,
                        initializing: false,
                        placeholderHeight: undefined
                    });
                    setTimeout(() => this.setState({ loadingMore: false }), 500);
                }
                _config.onTranslated = this.handleTranslated;

                if (this.props.blockConfig && this.props.blockConfig.slideshow) {
                    _config.items = parseInt(this.props.blockConfig.slideshow.columns, 10) || 1;
                    _config.responsive = { 0: { items: 1 } };
                    if (this.props.responsive) {
                        _config.responsive[1000] = { items: _config.items };
                        switch (_config.items) {
                            case 1:
                            case 2:
                                _config.responsive[600] = { items: _config.items };
                                break;
                            default:
                                _config.responsive[600] = { items: _config.items - 1 };
                                break;
                        }
                    } else {
                        _config.responsive[1000] = { items: _config.items };
                        _config.responsive[600] = { items: _config.items };
                    }
                    if (this.props.blockConfig.slideshow.columnSpacing && this.props.blockConfig.slideshow.columnSpacing.value) {
                        const margin = parseInt(this.props.blockConfig.slideshow.columnSpacing.value, 10);
                        if (!isNaN(margin)) {
                            _config.margin = margin;
                        }
                    }
                    if (this.props.blockConfig.slideshow.animationDuration && this.props.blockConfig.slideshow.animationDuration.length > 0) {
                        _config.smartSpeed = this.props.blockConfig.slideshow.animationDuration;
                    } else {
                        _config.smartSpeed = 1000;
                    }
                    if (this.props.blockConfig.slideshow.autoplayTimeout && this.props.blockConfig.slideshow.autoplayTimeout.length > 0) {
                        _config.autoplay = true;
                        _config.autoplayTimeout = parseFloat(_config.smartSpeed) + Math.max(parseFloat(this.props.blockConfig.slideshow.autoplayTimeout), 100.0);
                    } else {
                        _config.autoplay = false;
                    }
                }
                if (this.props.listData && this.props.listData.length < _config.items) {
                    _config.loop = false;
                }
                if (this.configHandler) {
                    this.configHandler(_config);
                }
                if (this.state.currentIndex) {
                    _config.startPosition = this.state.currentIndex;
                }
                const doc = this.props.frameDoc || document;
                const slider = doc.getElementById(this.state.sliderId);
                this.carousel = $(slider).owlCarousel(_config);
                this.setState({
                    config: _config
                });
            }, 200);
        }

        handleNext() {
            if (this.carousel) {
                this.carousel.trigger('next.owl.carousel');
            }
        }

        handlePrevious() {
            if (this.carousel) {
                this.carousel.trigger('prev.owl.carousel');
            }
        }

        handleRegisterConfigHandler(handler) {
            this.configHandler = handler;
        }

        handleReinit(debounce) {
            if (debounce == true) {
                if (this._reinitTimeoutId) {
                    clearTimeout(this._reinitTimeoutId);
                    this._reinitTimeoutId = undefined;
                }
                this._reinitTimeoutId = setTimeout(this.handleReinit, 300);
                return;
            }
            if (this.carousel && this.carousel.length > 0) {
                this.setState({
                    placeholderHeight: this.carousel[0].clientHeight
                });
            }
            this._destroySlider();
            this._initialize();
        }

        handleTranslated(event) {
            if (!event || !event.page) {
                return;
            }
            this.setState({
                page: event.page
            });
            if (!this.props.onLoadMore || !this.props.hasMore) {
                return;
            }
            let index;
            if (event.page.count == 0) {
                // Items per page > 1
                if (event.item) {
                    index = event.item.index;
                    if (index < event.item.count - 2) {
                        return;
                    }
                }
            } else {
                index = event.page.index;
                if (index < event.page.count - 2) {
                    return;
                }
            }
            this.setState({
                currentIndex: index,
                loadingMore: true
            });
            this.props.onLoadMore(event, this.handleReinit);
        }

        render() {
            let style = this.props.style ? { ...this.props.style } : {};
            if (this.props.visible == false) {
                style.display = 'none';
            } else if (this.state.initializing != false || this.state.loadingMore) {
                style.opacity = 0;
            }
            if (this.state.placeholderHeight) {
                style.maxHeight = `${this.state.placeholderHeight}px`;
            }
            let sliderProps = {};
            if (this.props.builder) {
                if (this.state.config) {
                    sliderProps['data-owl'] = JSON.stringify(this.state.config);
                } else {
                    sliderProps['data-owl'] = JSON.stringify(config);
                }
                if (this.props.legacy) {
                    style.opacity = 1;
                }
            }
            return (
                <>
                    <WrappedComponent
                        initializing={this.state.initializing != false}
                        page={this.state.page}
                        sliderId={this.state.sliderId}
                        sliderProps={sliderProps}
                        onDestroy={this._destroySlider}
                        onNext={this.handleNext}
                        onPrevious={this.handlePrevious}
                        onRegisterConfigHandler={this.handleRegisterConfigHandler}
                        onReinit={this.handleReinit}
                        {...this.props}
                        style={style}>
                        {this.props.children}
                    </WrappedComponent>
                    {
                        this.state.loadingMore &&
                        <div className="cont--whitelabel--loading"><span>Loading...</span></div>
                    }
                </>
            )
        }
    }
}

export { SlideshowDot, withSlideshowConfiguration, withSlideshowInitialization };